export default __webpack_public_path__ + "static/media/60.6ea44fab.jpg";